// variables.js
export const colors = {
  background: '#1c1c1e', // Preto fosco
  highlight: '#ff4757',  // Exemplo: vermelho coral
  accentBlue: '#1e90ff', // Azul claro
  accentGreen: '#2ed573', // Verde esmeralda
  accentYellow: '#ffa502', // Amarelo mostarda
  text: '#ffffff',        // Texto branco
};


export const fonts = {
  main: "'Roboto Mono', monospace",
};
